import React, { useState } from "react";
import { Link } from "gatsby"
import { Helmet } from "react-helmet";

const FaqSchema = ({ faqSchemaData }) => {
    //console.log("FAQSchemaData", faqSchemaData);
  if (!faqSchemaData || !Array.isArray(faqSchemaData)) return null;

  var faqschemaList = [];

   faqSchemaData.map((faqitem,i) =>{
        faqschemaList.push({
            "@type": "Question",
            "name": `${faqitem?.Accordion_Heading ? faqitem?.Accordion_Heading : faqitem?.Title}`, 
            "acceptedAnswer": {
                "@type": "Answer",
                "text": `${faqitem?.Accordion_Content ? faqitem?.Accordion_Content : faqitem?.Content}`
            }
        })
    })

  return (
      <Helmet>
            <script type="application/ld+json">{`{
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": ${JSON.stringify(faqschemaList, null, 2)}
                }`}
          </script> 
       </Helmet>
  );
};

export default FaqSchema;
